import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import { CreateActionContext } from "./CreateActionContext";
import ProductForm from "@beeldit/ecommerce/products/components/ProductForm";
import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import {TenantAndCommerceContext} from "@main/contexts/TenantAndCommerceContext";
import { useNavigate } from "react-router-dom";

function useCreateAction(formDefaultValues: any = {}, producerSelectorComponent: any): any {
  const initialize = useInitialize();
  const initializeFunction = () => initialize(formDefaultValues);

  const { tenantId, commerceId } = useContext(TenantAndCommerceContext);
  const navigate = useNavigate();

  /**
   * Form store success function definition
   */
  const onSuccessStore = (data: any) => {
    showSuccessMessage("successfull_action");
    navigate(`/panel/${tenantId}/${commerceId}/products/${data.id}`);
  };

  const store = useStore();
  const storeFunction = () => store(onSuccessStore);

  const contextInstance = useContext(CreateActionContext);
  const { element } = contextInstance;

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  const onSubmitFunction = () => formRef.current?.formElement.current.requestSubmit() //We pass the function for the submit of the modal

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      storeFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: CreateActionContext,
    className: "product-form",
    producerSelectorComponent: producerSelectorComponent
  };

  const actionTemplate = (
      <ProductForm formConfig={formConfig} />
  );

  /** END EDIT FORM ACTION */

  return {
    initializeFunction,
    onSubmitFunction,
    actionTemplate,
  };
}

export default useCreateAction;
